import { Cursos } from 'generated/graphql';

export const getCursoName = (curso: Cursos | Partial<Cursos>) => {
	const tipoCurso = curso?.identificadorNivel?.includes('school')
		? curso?.identificadorNivel
		: curso?.identificadorNivel?.slice(curso?.identificadorNivel?.lastIndexOf(' ') + 1);
	const nombreCurso = curso?.identificadorNivel?.replace(/[\W]*\S+[\W]*$/, '');
	if (curso?.nivel === 0 || tipoCurso?.includes('universidad')) {
		return `${curso?.identificadorNivel?.replace('universidad', '')}`;
	}
	if (curso?.identificadorNivel?.includes('nt')) {
		return `NT${curso?.nivel} ${nombreCurso}`;
	}
	return `${curso?.nivel}° ${tipoCurso} ${nombreCurso}`;
};

export const GetCursoNameAbreviacion = (curso: Cursos | Partial<Cursos>) => {
	const tipoCurso = curso?.identificadorNivel?.includes('school')
		? curso?.identificadorNivel
		: curso?.identificadorNivel?.slice(curso?.identificadorNivel?.lastIndexOf(' ') + 1);
	const nombreCurso = curso?.identificadorNivel?.replace(/[\W]*\S+[\W]*$/, '');
	if (curso.nivel === 0 || tipoCurso?.includes('universidad')) {
		return `${curso?.identificadorNivel?.replace('universidad', '')}`;
	}
	if (curso?.identificadorNivel?.includes('nt')) {
		return `NT${curso?.nivel} ${nombreCurso}`;
	}
	return `${curso.nivel}° ${tipoCurso} ${nombreCurso}`;
};
